import { useAskAIContext } from '@/context/AskAiContext';
import { Box, Button, Tooltip } from '@mui/material';
import React from 'react';

const AskAiAttachFromFolioButton = () => {
	const { isBusy, openSelectFiles, session, sharepointDriveId } = useAskAIContext();
	const sessionId = session?.sessionId ?? session?.id;

	const missingDrive = !sharepointDriveId;
	const disabled =
		!sessionId || isBusy || Boolean(session?.disabledReason) || missingDrive;

	return (
		<Tooltip
			title={
				missingDrive && sessionId
					? 'SharePoint folder is not available for this client or deal yet.'
					: null
			}
		>
			<span>
				<Box display='flex' justifyContent='flex-end'>
					<Button
						variant='text'
						size='small'
						sx={{ textTransform: 'none' }}
						onClick={openSelectFiles}
						disabled={disabled}
					>
						Attach from Folio
					</Button>
				</Box>
			</span>
		</Tooltip>
	);
};

export default AskAiAttachFromFolioButton;
